var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4909 4.70954L10.3472 0.084629C10.1258 -0.0282097 9.87282 -0.0282097 9.65029 0.084629L0.507078 4.70954C0.208624 4.86027 0.0115314 5.19203 0.000463188 5.56284C-0.0102167 5.93293 0.16448 6.27871 0.453096 6.45285L9.59618 11.9834C9.72227 12.0601 9.86046 12.0976 9.99904 12.0976C10.1383 12.0976 10.2763 12.0601 10.4026 11.9834L19.5461 6.45285C19.8345 6.27871 20.0094 5.93293 19.9989 5.56284C19.9864 5.19203 19.7898 4.86027 19.4909 4.70954Z",
    fill: "#556BB8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7401 8.85365L9.99909 14.1425L1.25952 8.85365C0.841123 8.60044 0.323052 8.78009 0.101298 9.25376C-0.122008 9.72721 0.0363775 10.3147 0.453605 10.5672L9.59669 16.0993C9.72278 16.1755 9.86097 16.2135 9.99955 16.2135C10.1388 16.2135 10.2768 16.176 10.4031 16.0993L19.5467 10.5672C19.9629 10.3147 20.1211 9.72721 19.8991 9.25376C19.6757 8.78002 19.1572 8.60037 18.7401 8.85365Z",
    fill: "#556BB8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.7401 12.6428L9.99909 17.9299L1.25952 12.6428C0.841123 12.3894 0.323052 12.5693 0.101298 13.0423C-0.122008 13.5157 0.0363775 14.1038 0.453605 14.356L9.59669 19.8863C9.72278 19.963 9.86097 20.001 9.99955 20.001C10.1388 20.001 10.2768 19.9635 10.4031 19.8863L19.5467 14.356C19.9629 14.1038 20.1211 13.5158 19.8991 13.0423C19.6757 12.5693 19.1579 12.3893 18.7401 12.6428Z",
    fill: "#556BB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedItem);
export default __webpack_public_path__ + "static/media/selected-item.2c1f903338aa14455fb9344040343fbc.svg";
export { ForwardRef as ReactComponent };